import browser from 'util/browser'
import { bridge } from 'util/appBridge'

export default {
  install(Vue, options) {
    Vue.prototype.$routeBack = function () {
      if (browser.isVkhybrid()) {
        bridge.appExcute({
          namespace: 'nz_apply/movetoback'
        })
      } else {
        history.back()
      }
    }
    /**
     * Modified on 2020/10/20 by Haoyang Wei
     * @param {String} name
     * @param {String} type
     * @param {Object} params nz_apply/browser桥的旧有参数字段，用于设定webview样式
     * @param {Object} config 若要使用新增的webview样式则需通过config字段传参，且与params为互斥关系，若传递config则不传params
     */
    Vue.prototype.$pushRoute = function (name, type = 'h5', params = {}, config = {}) {
      if (browser.isVkhybrid() || type === 'app' || type === 'others') {
        if (JSON.stringify(params) !== '{}' && type === 'app') {
          bridge.appExcute({
            namespace: 'nz_apply/browser',
            params: {
              url: `${location.origin}${this.$router.history.base}${name}`,
              params: JSON.stringify(params)
            }
          })
        } else if (JSON.stringify(params) !== '{}' && type === 'others') {
          bridge.appExcute({
            namespace: 'nz_apply/browser',
            params: {
              url: name,
              params: JSON.stringify(params)
            }
          })
        } else {
          bridge.appExcute({
            namespace: 'nz_apply/browser',
            params: {
              url: `${location.origin}${this.$router.history.base}${name}`,
              config: JSON.stringify(config)
            }
          })
        }
      } else if (browser.isParent()) {
        this.$router.replace(name)
      } else if (type === 'noSinglePage') {
        location.href = name
      } else {
        this.$router.push(name)
      }
    }
  }
}
